var map = {
	"./_back.png": "293e",
	"./achievements/claimedAccount.png": "39e7",
	"./achievements/fiftyCasts.png": "1637",
	"./achievements/fiftySummons.png": "bd3a",
	"./achievements/firstDuelWin.png": "ab11",
	"./achievements/hundredCasts.png": "c524",
	"./achievements/hundredSummons.png": "8771",
	"./achievements/twoHundredCasts.png": "e947",
	"./achievements/twoHundredSummons.png": "eefd",
	"./audio/chat-mention.mp3": "9e71",
	"./audio/credits.mp3": "1d0f",
	"./avatars/bash.png": "d0f8",
	"./avatars/cors.png": "5b11",
	"./avatars/dark_droid.png": "0495",
	"./avatars/delta.png": "9c2f",
	"./avatars/dummy.png": "6866",
	"./avatars/ghost.png": "4d7e",
	"./avatars/lenny.png": "b50d",
	"./avatars/mod.png": "112a",
	"./avatars/plague.png": "45ac",
	"./avatars/scrypt.png": "083f",
	"./avatars/shell.png": "2f77",
	"./avatars/spacewalker.png": "f76a",
	"./avatars/sudo.png": "3eb2",
	"./avatars/zed.png": "150f",
	"./back.jpg": "11aa",
	"./back.png": "336c",
	"./back2.png": "fff8",
	"./backgrounds/tatami.png": "142b",
	"./card-stack.png": "9726",
	"./caster-logo.png": "3bfe",
	"./chick.png": "3141",
	"./credits.png": "a6ae",
	"./dude.png": "1250",
	"./entypo.eot": "558b",
	"./entypo.ttf": "3881",
	"./entypo.woff": "d1c6",
	"./error.png": "1fe8",
	"./gear-logo.png": "4c3f",
	"./logo.png": "cf05",
	"./misc/app_adventure.png": "122c",
	"./misc/app_combat.png": "e387",
	"./misc/app_config.png": "555f",
	"./misc/app_dev.png": "f315",
	"./misc/app_landing.png": "dc74",
	"./misc/web_home.png": "71ad",
	"./misc/web_mockup.png": "e8e0",
	"./ranks/apprentice.png": "3a8b",
	"./ranks/crafter.png": "a8e1",
	"./ranks/engineer.png": "6cc1",
	"./ranks/junior.png": "87b7",
	"./ranks/mechanic.png": "6764",
	"./ranks/novice.png": "9317",
	"./ranks/scientist.png": "626d",
	"./text-logo-transparent.png": "c88f",
	"./text-logo.png": "8710",
	"./unknown.png": "c02d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";